

import Static from '@/components/Static.vue'; // @ is an alias to /src

export default {
  components: {
    Static
  }
}
